<template>
   <div class="inline" v-on:mouseover="hover(true)" v-on:mouseout="hoverOut">
     <slot></slot>
      <div class="user-popover rounded-lg ml-6 p-2 px-6 w-64" v-if="showPopup" transition="fade" v-on:mouseover="hover(true)" v-on:mouseout="hoverOut">
          <p v-if="message === 'discount-all'" class="text-left text-xs align-top mb-2 mt-1">Differing discounts apply depending on your Guild Plan</p>
          <p v-if="message === 'locked-enhanced-premium'" class="text-left text-xs align-top mb-2 mt-1">Available with the Guild <strong>Enhanced</strong> or <strong>Premium</strong> Plans</p>
          <p v-if="message === 'locked-standard-enhanced-premium'" class="text-left text-xs align-top mb-2 mt-1">Available with the Guild <strong>Standard</strong>, <strong>Enhanced</strong> or <strong>Premium</strong> Plans</p>
          <p v-if="message === 'locked-premium'" class="text-left text-xs align-top mb-2 mt-1">Available with the Guild <strong>Premium</strong> Plan</p>
        </div>
      </div>
</template>
<script>
export default {
  data () {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false
    }
  },
  props: [
    'message'
  ],
  methods: {
    hover (check) {
      if (!check) {
        return
      }
      let vm = this
      this.timer = setTimeout(function () {
        vm.showPopover()
      }, 200)
    },

    hoverOut () {
      let vm = this
      clearTimeout(vm.timer)
      this.timer = setTimeout(function () {
        if (!vm.isInInfo) {
          vm.closePopover()
        }
      }, 200)
    },

    hoverInfo () {
      this.isInInfo = true
    },

    hoverOutInfo () {
      this.isInInfo = false
      this.hoverOut()
    },

    showPopover () {
      this.showPopup = true
    },

    closePopover () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .inline{
    display: inline-block;
    position: relative;
  }
  .user-popover{
    position: absolute;
    left: 80%;
    bottom: 0%;
    background: #707070;
    border: 1px solid #fff;
    color: #fff;
    z-index:999;
  }

  .scrollbar {
    scrollbar-width: 1px; /* for Firefox */
    overflow-x: scroll !important;
  }

  .user-popover:before {
  content:"";
    position: absolute;
    height: 0px;
    width: 0px;
    bottom: 13px;
    left: -30px; /* 1px buffer for zooming problems while rendering*/
    border-width: 15px;
    border-color: transparent #707070 transparent transparent;
    border-style: solid;
  }

</style>
